import { z } from 'zod';
import { idSchema } from '../validation/id';
import { userGroupsSchema, userRolesSchema } from './user-types.schema';

export const creatorSchema = z.object({
  id: idSchema,
  groups: userGroupsSchema,
  roles: userRolesSchema,
  name: z.string().trim(),
});
export type Creator = z.infer<typeof creatorSchema>;
